// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1333":"0986a0ba","3690":"0089643e","4018":"98875e10","4711":"9df20093","5515":"98875e10","7025":"9df20093","7942":"32123ef9"}[chunkId] + ".chunk.css";
};